import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { IconHamburger } from 'svgIcons/MotionPortalIcons';

const ChartContextMenuButton = ({
    isHideDownload,
    showChartPopout,
    mainChartInst,
    chartRef,
    exportMenuRef,
    exportMenuOpen,
    setExportMenuOpen
}) => {
    if (isHideDownload) { return null; }
    const chart = showChartPopout ? mainChartInst : chartRef.current?.chart;
    if (!chart) { return null; }

    return (
        <div ref={exportMenuRef} className='anomaly-export-menu'>
            <button
                type='button'
                className='anomaly-export-menu-trigger'
                onClick={() => setExportMenuOpen(v => !v)}
            >
                <IconHamburger width='20' height='20' />
            </button>
            {exportMenuOpen &&
                <div className='anomaly-export-menu-dropdown'>
                    <button
                        type='button'
                        className='anomaly-export-menu-item'
                        onClick={() => { chart.exportChartLocal({ type: 'image/png' }); setExportMenuOpen(false); }}
                    >
                        {translate('ABB.Powertrain.Frontend.saveAsImage')}
                    </button>
                    <button
                        type='button'
                        className='anomaly-export-menu-item'
                        onClick={() => { chart.print(); setExportMenuOpen(false); }}
                    >
                        {translate('ABB.Powertrain.Frontend.printChart')}
                    </button>
                </div>
            }
        </div>
    );
};

ChartContextMenuButton.propTypes = {
    isHideDownload: PropTypes.bool,
    showChartPopout: PropTypes.bool,
    mainChartInst: PropTypes.object,
    chartRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
    exportMenuRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
    exportMenuOpen: PropTypes.bool.isRequired,
    setExportMenuOpen: PropTypes.func.isRequired
};

export default ChartContextMenuButton;
